<template>
    <PlanbordGridCell class="temp-agency name" info centeredVertically>
        <NameMarker>{{ company.name }}</NameMarker>
        <CqButton v-if="showOpenShiftMarketplaceFunctions" icon="plus" @click="$emit('open:addOpenShiftMarketplaceEmployee', company)" size="xs" margin="no-top-bottom" />
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {Company} from '@cquential/api';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import NameMarker from '@/components/Planbord/NameMarker.vue';
    import {CqButton} from '@cquential/ui';

    @Component({
        components: {
            PlanbordGridCell,
            NameMarker,
            CqButton,
        },
        emits: ['open:addOpenShiftMarketplaceEmployee'],
    })
    export default class CompanyNameCell extends Vue {
        @Prop({required: true}) public company!: Company;
        @Prop({type: Boolean}) public showOpenShiftMarketplaceFunctions!: boolean;
    }
</script>
